import { combineReducers } from 'redux'

import filtro from './filtroCovid'
import filtroAplicados from './filtroAplicados'
import resultados from './consultaContrato'

export default combineReducers({ filtro, filtroAplicados, resultados })
